import Button from "src/components/Button";
import DialogComponent from "../../../components/DialogComponent";
import moment from "moment";

type Props = {
    open: boolean;
    toggleDialog: (b: boolean) => void;
    setOpen: (b: boolean) => void;
    setCloseAllModals: (b: boolean) => void;
    closeAllModals: boolean;
    versionView?: number | null;
    setShowEditApprovers: any;
    showEditApprovers: any;
    card: any;
}

function ReturnToWorkModal(props: Props) {

    const { open, toggleDialog, setOpen, setCloseAllModals, closeAllModals, versionView, showEditApprovers, setShowEditApprovers, card } = props;

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="returnToWorkModal">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Подтвердите действие</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">Вы&nbsp;уверены, что хотите вернуть в работу версию от <strong>{card.PublicationDate && moment(card.PublicationDate).format("DD.MM.YYYY")}</strong>?</span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Отмена"
                            setCloseAllModals={setCloseAllModals}
                            closeAllModals={closeAllModals}
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Вернуть версию в работу"
                            customFunction={setShowEditApprovers}
                            paramsCustomFunction={!showEditApprovers}
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
}

export default ReturnToWorkModal;



